/*
 * Address lookup for any form field rendered with the loqate-lookup class.
 *
 * Searches go through our own /address-lookup/ views rather than straight to
 * Loqate, so the API key stays on the server.
 */
(function () {
    'use strict';

    var script = document.querySelector('script[data-loqate-find-url]');

    if (!script) {
        return;
    }

    var FIND_URL = script.getAttribute('data-loqate-find-url');
    var RETRIEVE_URL = script.getAttribute('data-loqate-retrieve-url');
    var COUNTRIES = script.getAttribute('data-loqate-countries') || '';
    var DEBOUNCE = 250;
    var MIN_LENGTH = 2;

    function AddressLookup(input) {
        this.input = input;
        this.targets = JSON.parse(input.getAttribute('data-loqate-targets') || '{}');
        this.container = '';
        this.containerText = '';
        this.results = [];
        this.selected = -1;
        this.timer = null;
        this.request = 0;

        this.build();
        this.listen();
    }

    AddressLookup.prototype.build = function () {
        var wrapper = document.createElement('div');
        wrapper.className = 'loqate-lookup-wrapper';

        this.input.parentNode.insertBefore(wrapper, this.input);
        wrapper.appendChild(this.input);

        this.list = document.createElement('ul');
        this.list.className = 'loqate-results';
        this.list.setAttribute('role', 'listbox');
        this.list.hidden = true;

        wrapper.appendChild(this.list);
    };

    AddressLookup.prototype.listen = function () {
        var self = this;

        this.input.addEventListener('input', function () {
            // clearing out what was selected drops us back to a fresh search
            if (self.container && self.input.value.indexOf(self.containerText) !== 0) {
                self.clearContainer();
            }
            self.schedule();
        });

        this.input.addEventListener('keydown', function (e) {
            self.keydown(e);
        });

        this.list.addEventListener('mousedown', function (e) {
            var item = e.target.closest('li[data-index]');

            if (item) {
                e.preventDefault();
                self.choose(parseInt(item.getAttribute('data-index'), 10));
            }
        });

        document.addEventListener('click', function (e) {
            if (!self.list.contains(e.target) && e.target !== self.input) {
                self.close();
            }
        });
    };

    AddressLookup.prototype.clearContainer = function () {
        this.container = '';
        this.containerText = '';
    };

    AddressLookup.prototype.searchText = function () {
        if (this.container && this.input.value.indexOf(this.containerText) === 0) {
            return this.input.value.slice(this.containerText.length).trim();
        }

        return this.input.value.trim();
    };

    AddressLookup.prototype.schedule = function () {
        var self = this;

        window.clearTimeout(this.timer);

        if (this.searchText().length < MIN_LENGTH && !this.container) {
            this.close();
            return;
        }

        this.timer = window.setTimeout(function () {
            self.find();
        }, DEBOUNCE);
    };

    AddressLookup.prototype.find = function () {
        var self = this;
        var request = ++this.request;

        var url = FIND_URL + '?text=' + encodeURIComponent(this.searchText());

        if (this.container) {
            url += '&container=' + encodeURIComponent(this.container);
        }

        if (COUNTRIES) {
            url += '&countries=' + encodeURIComponent(COUNTRIES);
        }

        fetch(url, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(function (response) { return response.json(); })
            .then(function (data) {
                // ignore anything that came back out of order
                if (request !== self.request) {
                    return;
                }

                if (data.error) {
                    self.message(data.error);
                    return;
                }

                self.show(data.results || []);
            })
            .catch(function () {
                if (request === self.request) {
                    self.message('Sorry, the address lookup is unavailable at the moment.');
                }
            });
    };

    AddressLookup.prototype.show = function (results) {
        this.results = results;
        this.selected = -1;
        this.list.innerHTML = '';

        if (!results.length) {
            this.message('No matching addresses found.');
            return;
        }

        results.forEach(function (result, index) {
            var item = document.createElement('li');
            item.setAttribute('data-index', index);
            item.setAttribute('role', 'option');
            item.className = 'loqate-result';

            var text = document.createElement('span');
            text.className = 'loqate-result-text';
            text.textContent = result.text;
            item.appendChild(text);

            if (result.description) {
                var description = document.createElement('span');
                description.className = 'loqate-result-description';
                description.textContent = result.description;
                item.appendChild(description);
            }

            this.list.appendChild(item);
        }, this);

        this.open();
    };

    AddressLookup.prototype.message = function (message) {
        this.results = [];
        this.selected = -1;
        this.list.innerHTML = '';

        var item = document.createElement('li');
        item.className = 'loqate-message';
        item.textContent = message;

        this.list.appendChild(item);
        this.open();
    };

    AddressLookup.prototype.open = function () {
        this.list.hidden = false;
    };

    AddressLookup.prototype.close = function () {
        this.list.hidden = true;
        this.selected = -1;
    };

    AddressLookup.prototype.highlight = function (index) {
        var items = this.list.querySelectorAll('li[data-index]');

        Array.prototype.forEach.call(items, function (item, position) {
            item.classList.toggle('selected', position === index);
        });

        this.selected = index;
    };

    AddressLookup.prototype.keydown = function (e) {
        if (this.list.hidden || !this.results.length) {
            return;
        }

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.highlight((this.selected + 1) % this.results.length);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            this.highlight((this.selected <= 0 ? this.results.length : this.selected) - 1);
        } else if (e.key === 'Enter' && this.selected > -1) {
            e.preventDefault();
            this.choose(this.selected);
        } else if (e.key === 'Escape') {
            this.close();
        }
    };

    AddressLookup.prototype.choose = function (index) {
        var result = this.results[index];

        if (!result) {
            return;
        }

        if (result.type !== 'Address') {
            this.container = result.id;
            this.containerText = result.text + ', ';
            this.input.value = this.containerText;
            this.input.focus();
            this.find();
            return;
        }

        this.retrieve(result);
    };

    AddressLookup.prototype.retrieve = function (result) {
        var self = this;
        var request = ++this.request;

        fetch(RETRIEVE_URL + '?id=' + encodeURIComponent(result.id), {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(function (response) { return response.json(); })
            .then(function (data) {
                if (request !== self.request) {
                    return;
                }

                if (data.error || !data.address) {
                    self.message(data.error || 'Sorry, we could not load that address.');
                    return;
                }

                self.fill(data.address);
                self.input.value = result.text + ', ' + result.description;
                self.clearContainer();
                self.close();
            })
            .catch(function () {
                if (request === self.request) {
                    self.message('Sorry, the address lookup is unavailable at the moment.');
                }
            });
    };

    AddressLookup.prototype.fill = function (address) {
        Object.keys(this.targets).forEach(function (name) {
            var field = document.getElementById(this.targets[name]);
            var value = address[name] || '';

            if (!field) {
                return;
            }

            if (field.tagName === 'SELECT') {
                // country comes back as a two character iso code
                var matched = Array.prototype.some.call(field.options, function (option) {
                    return option.value.toUpperCase() === value.toUpperCase();
                });

                if (!matched) {
                    return;
                }

                field.value = value.toUpperCase();
            } else {
                field.value = value;
            }

            field.dispatchEvent(new Event('change', {bubbles: true}));
        }, this);
    };

    Array.prototype.forEach.call(document.querySelectorAll('.loqate-lookup'), function (input) {
        new AddressLookup(input);
    });
}());
